import logins from './mall/login/login'
import DMs from './mall/dm/dm'
export { 
  logins,
  DMs
};